function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48.1 56"
}, props), React.createElement("path", {
  d: "M42.9 0H5.1A5.12 5.12 0 000 5.1v30.5h48V5.1A5.12 5.12 0 0042.9 0zM0 50.9A5.12 5.12 0 005.1 56H43a5.12 5.12 0 005.1-5.1V38.2H0zm20.1-5.8a2.8 2.8 0 012.8 2.8 2.73 2.73 0 01-2.8 2.8 2.8 2.8 0 110-5.6zm-10.1 0a2.8 2.8 0 012.8 2.8 2.73 2.73 0 01-2.8 2.8 2.8 2.8 0 110-5.6z",
  fill: "#828282"
})));